import { render, staticRenderFns } from "./form-sub-title.vue?vue&type=template&id=21e31caa"
import script from "./form-sub-title.vue?vue&type=script&lang=js"
export * from "./form-sub-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports